import { render, staticRenderFns } from "./popupStigler.vue?vue&type=template&id=e48fcbee&lang=pug&"
import script from "./popupStigler.vue?vue&type=script&lang=js&"
export * from "./popupStigler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports